import {
  LuSmartphone,
  LuClock,
  LuBuilding2,
  LuUsers,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
  LuSettings,
  LuShieldCheck,
  LuShield,
  LuPercent,
} from "react-icons/lu";

export const BrandingHeroData = {
  backgroundImage: "/images/serviceBanners/Branding.webp",
  whiteImage: "/images/serviceBanners/BrandingWhite.webp",
  subTitle: "Brand Strategy & Identity Services",
  title: (
    <>
      High Performance <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Brand Building</span> Systems
    </>
  ),
  description:
    "We build strong brand building systems that shape perception, enhance recognition, and establish trust by combining strategic positioning, consistent identity, and meaningful communication to create long term market impact and growth.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get a Free Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Visual Identity Systems",
      desc: "Develop complete visual identity including logo, typography, and color palette.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Consistent Brand Messaging",
      desc: "Create consistent messaging, tone of voice, and storytelling systems.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Market Positioning Structure",
      desc: "Establish unique value propositions that resonate with the right audience.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Scalable Brand Architecture",
      desc: "Build structured brand systems that ensure consistency across products.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const brandingStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Brands Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Reach Growth",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Brand Consistency",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Recognition",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const brandingSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE DELIVER",
  buildTitle: "High Performance Brand Building Systems",
  buildCards: [
    {
      title: "Custom Brand Identity Design",
      desc: "Develop complete visual identity including logo, typography, color palette, and brand style system aligned with your business vision.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Brand Messaging & Communication",
      desc: "Create consistent messaging, tone of voice, taglines, and storytelling systems across all brand touchpoints.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Brand Architecture Development",
      desc: "Build structured brand systems that ensure consistency across products, services, and platforms.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Brand Guidelines Creation",
      desc: "Document complete brand rules for design, communication, and usage to maintain uniformity across teams.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Brand Performance Optimization",
      desc: "Analyze brand perception and improve positioning for stronger market impact and recognition.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Enterprise Brand Solutions",
      desc: "Design scalable branding systems for large organizations with multi-channel presence.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Brand Engineering Framework",
  processTitle: "How We Build Scalable Brand Systems",
  processSteps: [
    {
      step: "01",
      title: "Strategy Architecture Planning",
      description: "Define brand structure, positioning roadmap, and long-term growth direction.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Brand Development",
      description: "Execute iterative brand development cycles with continuous refinement and improvement.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Identity System Development",
      description: "Create reusable brand elements including visual identity, messaging, and communication systems.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Brand Communication System",
      description: "Ensure consistent messaging, tone, and storytelling across all channels.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Brand Optimization",
      description: "Improve brand perception, visibility, and market positioning through data insights.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance",
      description: "Ensure consistency, clarity, and strong brand alignment across all platforms.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN BRAND SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Brand Systems",
  benefits: [
    "Strong and consistent brand identity",
    "Better market recognition and trust",
    "Scalable brand architecture",
    "Clear communication systems",
    "Improved customer perception",
    "Long-term brand value creation",
    "Sustainable business growth foundation",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const brandingPortfolioData = {
  subtitle: "OUR WORK",
  title: "Brand Campaigns We're Proud Of",
  buttonText: "View Case Studies",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};

export const brandingTechnologiesData = {
  techTitle: "OUR BRAND TOOL STACK",
  technologies: [
    { name: "Adobe Illustrator", icon: "Palette" },
    { name: "Figma", icon: "Provider" },
    { name: "Adobe Photoshop", icon: "Vite" },
    { name: "Brand Guidelines", icon: "Search" },
  ],
  trustTitle: "TRUSTED BY GOOGLE PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const brandingAboutData = [
  {
    title: "Brand Strategy Services for Long-Term Business Growth",
    content: (
      <>
        A successful brand is built on more than visuals and marketing materials. Professional Brand Strategy Services help businesses create a clear market presence, strengthen
        customer trust, and establish meaningful differentiation in competitive industries. Many organizations struggle to communicate their value effectively, which can limit
        growth and recognition. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, brand strategies are developed around business objectives, audience
        insights, and market opportunities to help companies build stronger and more memorable identities.
      </>
    ),
  },
  {
    title: "Brand Identity Design Services That Strengthen Recognition",
    content: (
      <>
        Customers often form opinions about a brand within moments of their first interaction. Effective Brand Identity Design Services help businesses create a recognizable
        presence that reflects their values, personality, and market position. Companies investing in strategic branding often experience stronger customer engagement because their
        identity remains consistent across digital and offline channels. Tycho Technologies focuses on creating practical brand systems that improve recognition while supporting
        long-term business goals and audience connection.
      </>
    ),
  },
  {
    title: "Brand Development Services for Sustainable Market Positioning",
    content: (
      <>
        Building a successful brand requires continuous refinement and alignment with customer expectations. Reliable Brand Development Services help organizations strengthen
        credibility, improve communication, and create stronger relationships with their target audience. Businesses that invest in structured branding frameworks often improve
        customer loyalty because messaging and experiences remain consistent throughout the customer journey. A well-developed brand also supports future expansion by creating a
        stronger foundation for business growth.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Brand Positioning Services",
    content: (
      <>
        The demand for professional Brand Positioning Services continues to grow as companies seek clearer differentiation and stronger market influence. Businesses working with a
        trusted <b className="text-text-primary font-semibold">Branding Agency India</b> often focus on creating unique value propositions that resonate with the right audience and
        strengthen competitive advantage. Tycho Technologies helps organizations develop customized branding frameworks designed around measurable business objectives and long-term
        market success. A strong brand position improves customer perception, builds trust, and creates lasting business value over time.
      </>
    ),
  },
];

// 7. FAQs
export const brandingFaqData = [
  {
    q: "What are Brand Strategy & Identity Services, and why are they important for business growth?",
    a: "Brand Strategy & Identity Services help businesses create a clear market position, consistent messaging, and a recognizable visual identity. A strong brand improves customer trust, market visibility, and long-term business growth.",
  },
  {
    q: "How can professional branding services improve customer recognition?",
    a: "Professional branding services create consistency across logos, messaging, design elements, and communication channels. This consistency helps customers remember your business, build trust faster, and differentiate your brand from competitors.",
  },
  {
    q: "Why should businesses choose Tycho Technologies for branding services?",
    a: "Tycho Technologies develops customized branding systems that align with business goals, target audiences, and market opportunities. The focus is on creating scalable brand frameworks that strengthen recognition, improve positioning, and support sustainable growth.",
  },
  {
    q: "What is included in a complete brand identity development process?",
    a: "A complete brand identity development process typically includes logo design, typography selection, color palette creation, brand messaging, communication guidelines, brand architecture, and documentation to ensure consistency across all platforms.",
  },
  {
    q: "How does Tycho Technologies help businesses strengthen their market positioning?",
    a: "Tycho Technologies combines brand strategy, audience insights, and competitive analysis to create strong positioning frameworks. This helps businesses communicate their value more effectively, improve customer perception, and build a lasting competitive advantage.",
  },
];
